import variables from '../../styles/variables.module.scss';
import casebg from '../../assets/cases/yachtsafe-caseimg.jpg';

export default {
  path: '/cases/yachtsafe',
  color: variables.yachtsafe,
  case: null,
  casebg,
  title: 'Yachtsafe',
  headline: 'iOS & Android application',
  description: 'A high-tech GPS-alarm system',
  isWeb: false,
  isAndroid: false,
};
